module.exports = __webpack_public_path__ + "img/goldregen-2020-026.d20145a6.jpg";